export enum FirstAddedItems {
  Both = 'both',
  Digital = 'digital',
  NoItems = 'noItems',
  Physical = 'physical',
}

export enum CheckoutV2Steps {
  PersonalInfo = 1,
  DeliveryInfo = 2,
  PaymentMethods = 3,
}

export enum CheckoutV2ShippingMethods {
  Digital = 'digital',
  Physical = 'physical',
}

export enum CheckoutV2ShippingTypes {
  IsDigital = 'isDigital',
  IsPhysical = 'isPhysical',
}
